export * from './applet.module';
